import { useEffect, useState } from 'react';

const COLORS = ['#3fd66a', '#fbbf24', '#60a5fa', '#f472b6', '#22d3ee'];

interface Piece { id: number; left: number; cx: string; cr: string; delay: number; color: string }

let nextId = 1;
const listeners = new Set<(pieces: Piece[]) => void>();
let pieces: Piece[] = [];

function emit() { for (const l of listeners) l([...pieces]); }

export function fireConfetti(count = 24): void {
  const burst: Piece[] = Array.from({ length: count }).map(() => ({
    id: nextId++,
    left: 40 + Math.random() * 20,
    cx: `${(Math.random() - 0.5) * 60}vw`,
    cr: `${Math.random() * 720 - 360}deg`,
    delay: Math.random() * 200,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
  }));
  pieces = [...pieces, ...burst];
  emit();
  setTimeout(() => {
    const ids = new Set(burst.map((p) => p.id));
    pieces = pieces.filter((p) => !ids.has(p.id));
    emit();
  }, 3200);
}

export default function ConfettiContainer() {
  const [list, setList] = useState<Piece[]>(pieces);
  useEffect(() => { listeners.add(setList); return () => { listeners.delete(setList); }; }, []);
  if (list.length === 0) return null;
  return (
    <div className="fixed inset-0 z-[80] pointer-events-none overflow-hidden">
      {list.map((p) => (
        <span
          key={p.id}
          className="absolute top-0 w-2 h-3 rounded-sm"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            // CSS vars consumed by @keyframes confetti-fall in styles.css
            ['--cx' as any]: p.cx,
            ['--cr' as any]: p.cr,
            animation: `confetti-fall 2800ms ease-in ${p.delay}ms forwards`,
          }}
        />
      ))}
    </div>
  );
}
